module.exports = __webpack_public_path__ + "static/media/twitter-grey.c0441afe.svg";